import { z } from 'zod';
import { ActionSchema } from '../actions';

export const QuizBlockSchema = z.object({
  id: z.string().min(1),
  type: z.literal('quiz'),
  rect: z.object({
    x: z.number().int().nonnegative(),
    y: z.number().int().nonnegative(),
    w: z.number().int().positive(),
    h: z.number().int().positive()
  }),
  on: z.object({ tap: z.array(ActionSchema).optional() }).optional(),
  props: z.object({ question: z.string().min(1), choices: z.array(z.string().min(1)) })
});
export type QuizBlock = z.infer<typeof QuizBlockSchema>;